module.exports = __webpack_public_path__ + "img/award04_14.9e6ce797.png";